<template>
    <div v-bind:class="'alert-'+alertMessage.alert_context" class="alert alert-block alert">
        <div @click="$emit('openAlert')" class="title-message-open-alert raw" >
            <span v-html="alertMessage.message"></span>
        </div>
        <span class="fa fa-times-circle fa-2x close-btn"
              @click="$emit('setAlertAsClosed')"
              v-if="!alertMessage.is_confirmation_needed">
        </span>

    </div>
</template>

<script>
    export default {
        props: {
            alertMessage : Object
        }
    }
</script>
